import { Paper, Text } from "@mantine/core";

export function SystemEmailRegistryEmptyState({
  filtered,
}: {
  filtered: boolean;
}) {
  const message = filtered
    ? "No system emails match the current search and filters."
    : "No system emails are registered yet.";
  return (
    <Paper p="xl" withBorder>
      <Text c="dimmed" ta="center">
        {message}
      </Text>
    </Paper>
  );
}
